import React, { useContext } from 'react';
import FormInput from '../AboutOneForm/FormInput';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { useDispatch } from 'react-redux';
import ChevronGray from '../../../../../Assets/StorefrontIcons/ChevronGray.svg';
import { setSelectedFeatureTwoSection } from '../../../../../Features/storefrontSlice';
import ImageInput from './ImageInput';

function FeatureSection({ feature, isSelected, isFirst }) {
    const dispatch = useDispatch();

    const {
        setFeaturesTwo,
    } = useContext(StorefrontContext);

    function handleSelectFeatureSection() {
        dispatch(setSelectedFeatureTwoSection(feature.title));
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFeaturesTwo((prevFeature) =>
            prevFeature.map((item) =>
                item.title === feature.title
                    ? { ...item, [name]: value } 
                    : item
            )
        );
    }

    return (
        <div className='flex flex-col'>
            <button onClick={handleSelectFeatureSection} className={`outline-none bg-[#FFFFFF] ${isSelected && 'bg-[#FAFAFA]'} hover:bg-[#FAFAFA] ${!isFirst && 'border-t border-[#EAEAEA]'} p-3 flex items-center justify-between`}>
                <p className='font-medium text-base text-[#000000]'>{feature.title}</p>

                <div className={`size-6 flex items-center justify-center transition-all duration-300 ease-linear ${isSelected ? '' : '-rotate-90'}`}>
                    <img src={ChevronGray} alt="" />
                </div>
            </button>

            {
                isSelected && 
                <div className='flex flex-col gap-3 p-3'>
                    <ImageInput 
                        feature={feature} 
                    />

                    <FormInput 
                        // errorText={formErrors.altText} 
                        inputOptions={{
                            name: "altText",
                            id: "altText",
                            placeholder: 'Describe your image for people with visual impairments',
                            value: feature.altText,
                            onChange: handleChange,
                        }} 
                        title='Alt Text' 
                    />

                    <FormInput 
                        // errorText={formErrors.heading} 
                        inputOptions={{
                            name: "heading",
                            id: "heading",
                            placeholder: 'Write heading here',
                            value: feature.heading,
                            onChange: handleChange,
                        }} 
                        title='Heading' 
                    />
                </div>
            }
        </div>
    );
}

export default FeatureSection;
